import {
  Box,
  Button,
  Collapse,
  ExpandMoreRoundedIcon,
  FilterListOutlinedIcon,
  Flex,
  Rotate,
  SearchInput,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useAdminBlockedUsersListSearchParams } from '../../hooks';
import { BlockedUsersExportButton } from '../blocked-users-export-button';
import { BlockedUsersListFilterSection } from '../blocked-users-filter-section';

export default function BlockedUsersSearchFilterSection() {
  const [{ blockedTypes, examCenters, search }, { changeSearch }] =
    useAdminBlockedUsersListSearchParams();
  const isFilterActive = blockedTypes.length > 0 || examCenters.length > 0;

  const [isExpand, { toggle }] = useDisclosure(isFilterActive);

  return (
    <Box>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ flexBasis: 300 }}>
          <SearchInput
            defaultValue={search}
            placeholder='ค้นหารายชื่อ...'
            onChange={changeSearch}
          />
        </Box>
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <BlockedUsersExportButton />
          <Button
            variant='outlined'
            color='secondary'
            startIcon={<FilterListOutlinedIcon />}
            endIcon={
              <Rotate in={isExpand}>
                <ExpandMoreRoundedIcon />
              </Rotate>
            }
            onClick={toggle}
          >
            Filter
          </Button>
        </Flex>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <BlockedUsersListFilterSection />
      </Collapse>
    </Box>
  );
}
